import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('page-list', (editor, opts = {}) => {
  let c = opts;
  const default_types = {
    pageList: 'page-list',
  };
  const default_labels = {
    pageList: 'Page List',
  };
  const options = {
    ...{
      pfx: 'page-list',
      labels: default_labels,
      types: default_types,
      labelPageListCategory: 'Advanced',
    },
    ...opts,
  };
  for (let name in options) {
    if (!(name in c)) c[name] = options[name];
  }
  loadComponents(editor, opts);
});
